import { InputAdornment, type TextFieldProps } from '@mui/material'
import { useMemo } from 'react'
import {
  useRecurrenceDispatch,
  useRecurrencePeriod,
  useRecurrenceType,
} from '../../../providers/StateProvider'
import { useTexts } from './useTexts'

export function useRecurrencePeriodProps() {
  const type = useRecurrenceType()
  const value = useRecurrencePeriod()
  const dispatch = useRecurrenceDispatch()
  const texts = useTexts()

  return useMemo<TextFieldProps>(
    () => ({
      label: texts.label,
      type: 'number',
      value,
      onChange: e => {
        dispatch({
          type: 'recurrencePeriod:change',
          recurrencePeriod: Number(e.target.value),
        })
      },
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            {texts.info(value, type as uui.domain.client.rm.RecurrenceType)}
          </InputAdornment>
        ),
      },
      testId: 'RecurrencePeriod',
      trackId: 'RecurrencePeriod',
    }),
    [texts, value, type, dispatch],
  )
}
